/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Px } from '../assets/posize';
import HeaderBlack from 'components/HeaderBlack';

import '../assets/styles/class.scss';

class SOUL extends React.Component {
  render() {
    return (
      <div
        className={`s-ou-l position ${css(styles.group, styles.group_layout)}`}
      >
        <div className="header-container">
          <HeaderBlack />
        </div>

        <div className={css(styles.flex, styles.flex_layout)}>
          <div className={css(styles.flex_item)}>
            <div className={css(styles.flex1, styles.flex1_layout)}>
              <a
                href="/soul1"
                onClick={() => window.open('/soul1', '_self')}
                style={{
                  '--src': `url(${
                    require('assets/2ed8626faeef5155288504eaa8b8d5c9.png')
                      .default
                  })`
                }}
                className={css(styles.photo, styles.photo_layout)}
              />
              <a
                href="/soul2"
                onClick={() => window.open('/soul2', '_self')}
                style={{
                  '--src': `url(${
                    require('assets/81ede6bd95cb206c09cd00489bfe12eb.png')
                      .default
                  })`
                }}
                className={css(styles.photo, styles.photo_layout)}
              />
            </div>
          </div>
          <div className={css(styles.flex_item)}>
            <div className={css(styles.flex2, styles.flex2_layout)}>
              <a
                href="/soul3"
                onClick={() => window.open('/soul3', '_self')}
                style={{
                  '--src': `url(${
                    require('assets/bae448a323457bcc80152b07fcf9f828.png')
                      .default
                  })`
                }}
                className={css(styles.photo, styles.photo_layout)}
              />
              <a
                href="/soul7"
                onClick={() => window.open('/soul7', '_self')}
                style={{
                  '--src': `url(${
                    require('assets/eb89f2c4512b2af01672e4d00532709f.png')
                      .default
                  })`
                }}
                className={css(styles.photo, styles.photo_layout)}
              />
            </div>
          </div>
          <div className={css(styles.flex_spacer)} />
          <div className={css(styles.flex_item)}>
            <div className={css(styles.flex3, styles.flex3_layout)}>
              <a
                href="/soul8"
                onClick={() => window.open('/soul8', '_self')}
                style={{
                  '--src': `url(${
                    require('assets/663d4fb46e78015477a20554401f8fb5.png')
                      .default
                  })`
                }}
                className={css(styles.photo, styles.photo_layout)}
              />
              <a
                href="/soul4"
                onClick={() => window.open('/soul4', '_self')}
                style={{
                  '--src': `url(${
                    require('assets/8a50e165329c35034ee139d4aa8fa1e3.png')
                      .default
                  })`
                }}
                className={css(styles.photo, styles.photo_layout)}
              />
            </div>
          </div>
          <div className={css(styles.flex_item1)}>
            <div className={css(styles.flex4, styles.flex4_layout)}>
              <a
                href="/soul6"
                onClick={() => window.open('/soul6', '_self')}
                style={{
                  '--src': `url(${
                    require('assets/621563901c64e3afd45172d8b0643d22.png')
                      .default
                  })`
                }}
                className={css(styles.photo, styles.photo_layout)}
              />
              <a
                href="/soul5"
                onClick={() => window.open('/soul5', '_self')}
                style={{
                  '--src': `url(${
                    require('assets/8d090cde74df4ec34ec6243bd826419c.png')
                      .default
                  })`
                }}
                className={css(styles.photo, styles.photo_layout)}
              />
            </div>
          </div>
        </div>

        <Px
          x="0px 1440.5fr 0px"
          y="931.54fr minmax(0px, max-content) 0px"
          absolute
          className={css(styles.group1)}
          lgX="0px 1440.5fr 0px"
          lgY="466fr minmax(0px, max-content) 0px"
          mdX="0px 1440.5fr 0px"
          mdY="233fr minmax(0px, max-content) 0px"
          smX="0px 1440.5fr 0px"
          smY="117fr minmax(0px, max-content) 0px"
          xsX="0px 1440.5fr 0px"
          xsY="59fr minmax(0px, max-content) 0px"
          xxsX="0px 1440.5fr 0px"
          xxsY="30fr minmax(0px, max-content) 0px"
          tnX="0px 1440.5fr 0px"
          tnY="15fr minmax(0px, max-content) 0px"
        >
          <div
            style={{
              '--src': `url(${
                require('assets/03b6008b189bc325bcb00c8dc69700ea.svg').default
              })`
            }}
            className={css(styles.cover_group, styles.cover_group_layout)}
          />

          <div
            onClick={() => window.open('/', '_self')}
            className={`${css(
              styles.cover_group1,
              styles.cover_group1_layout
            )} cursor-pointer`}
          >
            <div className={css(styles.background, styles.background_layout)} />
            <h5 className={css(styles.highlights, styles.highlights_layout)}>
              {'重新探索'}
            </h5>
          </div>
        </Px>
      </div>
    );
  }
}

export default SOUL;

SOUL.inStorybook = true;

const styles = StyleSheet.create({
  group: {
    display: 'flex',
    backgroundColor: 'rgb(255,255,255)'
  },
  group_layout: {
    position: 'absolute',
    flexGrow: 1,
    inset: 0
  },
  flex: {
    display: 'flex',
    '@media (max-width: 991.98px)': {
      flexWrap: 'wrap',
      rowGap: 0
    }
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_item: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 360px',
    '@media (max-width: 991.98px)': {
      flex: '0 0 50%'
    }
  },
  flex1: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex1_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '0px 0px 0.45px'
  },
  photo: {
    background: 'var(--src) center center / cover no-repeat',
    display: 'block',
    borderRadius: '0px 0px 0px 0px'
  },
  photo_layout: {
    flex: '1 1 auto'
  },
  flex2: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex2_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '0px 0px 0.45px'
  },
  flex_spacer: {
    flex: '0 0 auto',
    '@media (max-width: 991.98px)': {
      display: 'none'
    }
  },
  flex3: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex3_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '0px 0px 0.45px'
  },
  flex_item1: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 360.5px',
    '@media (max-width: 991.98px)': {
      flex: '0 0 50%'
    }
  },
  flex4: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex4_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '0px 0.5px 0.45px 0px'
  },
  group1: {
    display: 'flex',
    width: '100%',
    height: '100%'
  },
  cover_group: {
    display: 'flex',
    background: 'var(--src) center center / cover no-repeat',
    borderRadius: '0px 0px 0px 0px',
    opacity: 0.5
  },
  cover_group_layout: {
    position: 'relative',
    minHeight: 92.91,
    flexGrow: 1
  },
  cover_group1: {
    display: 'flex'
  },
  cover_group1_layout: {
    position: 'absolute',
    height: 45,
    width: 344,
    minWidth: 344,
    margin: '32px auto 15.91px',
    inset: '0px 0px auto',
    '@media (max-width: 1199.98px)': {
      margin: '16px auto 15.91px'
    },
    '@media (max-width: 991.98px)': {
      margin: '15.91px auto'
    },
    '@media (max-width: 383.98px)': {
      width: 258,
      minWidth: 258
    }
  },
  background: {
    border: '1px solid rgb(255,255,255)',
    borderRadius: '0px 0px 0px 0px'
  },
  background_layout: {
    position: 'absolute',
    height: 45,
    flexGrow: 1,
    inset: '0px 0px auto'
  },
  highlights: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '16px/1.75 "PingFangSC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights_layout: {
    height: 28,
    width: 68,
    minWidth: 68,
    margin: '8.5px auto'
  }
});
